import { ERORR_MESSAGE, INFO_MESSAGE, SUCCESS_MESSAGE } from "./actions";

export const errorMessage = (error, title = "Error!") => ({
  type: ERORR_MESSAGE,
  error,
  errorTitle: title,
});

export const successMessage = (message, description) => ({
  type: SUCCESS_MESSAGE,
  message,
  description,
});

export const infoMessage = (info) => ({
  type: INFO_MESSAGE,
  info,
});
